import PodcastPoster from "@elements/Card/Thumbnail/PodcastPoster";
import VideoPoster from "@elements/Card/Thumbnail/VideoPoster";
import Date from "@elements/Typography/Date";
import { Link } from "react-router";
import { twMerge } from "tailwind-merge";

export type ThumbnailLinkCard<T> = T & {
  id?: string;
  description: string;
  name: string;
  published_at: string;
  nowPlaying: boolean;
  thumbnail: string;
  formattedTime?: string | undefined;
  variant: "video" | "podcast";
  customCardStyles?: string;
  isHideDateTime?: boolean;
  isDark?: boolean;
  videoPosterDimensions?: string;
};

export default function ThumbnailLinkCard<T>(props: ThumbnailLinkCard<T>) {
  const {
    name,
    published_at,
    nowPlaying,
    thumbnail,
    formattedTime,
    variant,
    customCardStyles,
    isHideDateTime,
    videoPosterDimensions,
    isDark,
    id,
  } = props;

  const videoLink = "/videos/" + id;

  return (
    <div
      id={`thumbnail-card-${id}`}
      className={twMerge("flex py-2 lg:py-4 gap-4", customCardStyles)}
      data-testid="thumbnail-card"
    >
      <Link
        reloadDocument
        to={videoLink}
        className={twMerge(variant === "video" && "inline-flex")}
      >
        {variant === "video" && (
          <VideoPoster
            videoPosterDimensions={videoPosterDimensions}
            nowPlaying={nowPlaying}
            src={thumbnail}
            formattedTime={formattedTime}
          />
        )}
        {variant === "podcast" && <PodcastPoster src={thumbnail} />}
      </Link>

      <Link
        reloadDocument
        to={videoLink}
        className="flex flex-col w-full cursor-pointer"
      >
        <h4
          className={twMerge(
            "text-[16px] font-secondary text-black-200 leading-xs text-start",
            variant === "podcast" && "font-semibold",
            variant === "video" && isDark ? "text-[#FAFAFA]" : "text-gray-100",
          )}
          data-testid="name"
        >
          {name}
        </h4>
        {isHideDateTime ? null : (
          <div
            className={twMerge(
              "flex flex-col-reverse items-end justify-between w-full lg:items-center lg:flex-row",
              variant === "video" && "items-start",
            )}
          >
            <Date>{published_at}</Date>
          </div>
        )}
      </Link>
    </div>
  );
}
